<template>
  <v-card
    rounded="lg"
    class="fee-preview-card"
    style="border: 1px solid #e0e0e0"
  >
    <div class="d-flex justify-end" style="margin-bottom: -50px">
      <v-btn @click="copyAsImage" color="primary" class="ma-3"> Copiar </v-btn>
    </div>
    <div ref="componentToCopy">
      <div class="pa-3 pt-5">
        <h6 class="text-center flex-1">Simulação</h6>
        <v-text-field
          v-model="ticketPrice"
          label="O ingresso custa"
          dense
          type="number"
          outlined
          prefix="R$"
          hide-details
        ></v-text-field>
      </div>
      <v-divider></v-divider>
      <!-- Placeholder -->
      <!-- <div class="pa-3">
      <p class="text-center my-6">
        Em breve, você poderá ver aqui o valor final do ingresso com a taxação
        aplicada.
      </p>
    </div> -->

      <!-- Online -->
      <div class="pa-3">
        <p class="text-center mb-0 font-weight-bold text-16">No site</p>
        <div class="d-flex align-center justify-space-between">
          <span>O cliente paga</span>
          <b :class="onlineFee.outerFee !== 0 ? 'error--text' : ''">
            {{ (parseTicketPrice + onlineFee.outerFee) | currency }}
          </b>
        </div>
        <div class="d-flex align-center justify-space-between">
          <span>A produtora recebe</span>
          <b
            :class="
              onlineFee.outerFee - onlineFee.innerFee !== 0 ? 'error--text' : ''
            "
          >
            {{
              (parseTicketPrice + onlineFee.outerFee - onlineFee.innerFee)
                | currency
            }}
          </b>
        </div>
        <div class="d-flex align-center justify-space-between">
          <span>A ticketeira recebe</span>
          <b>{{ onlineFee.innerFee | currency }}</b>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Offline -->
      <div class="pa-3">
        <p class="text-center mb-0 font-weight-bold text-16">Com promoter</p>
        <div class="d-flex align-center justify-space-between">
          <span>O cliente paga</span>
          <b :class="offlineFee.outerFee !== 0 ? 'error--text' : ''">{{
            (parseTicketPrice + offlineFee.outerFee) | currency
          }}</b>
        </div>
        <div class="d-flex align-center justify-space-between">
          <span>A produtora recebe</span>
          <b
            :class="
              offlineFee.outerFee - offlineFee.innerFee !== 0
                ? 'error--text'
                : ''
            "
          >
            {{
              (parseTicketPrice + offlineFee.outerFee - offlineFee.innerFee)
                | currency
            }}
          </b>
        </div>
        <div class="d-flex align-center justify-space-between">
          <span>A ticketeira recebe</span>
          <b>{{ offlineFee.innerFee | currency }}</b>
        </div>
      </div>

      <v-divider></v-divider>
      <!-- PDV -->
      <div class="pa-3">
        <p class="text-center mb-0 font-weight-bold text-16">Nos PDVs</p>
        <div class="d-flex flex-column gap-2">
          <div v-for="paymentType in pdvPaymentTypes" :key="paymentType">
            <b>{{ paymentTypes[paymentType].text }}</b>
            <div class="d-flex align-center justify-space-between">
              <span>O cliente paga</span>
              <b
                :class="
                  pdvFees[paymentType].outerFee !== 0 ? 'error--text' : ''
                "
              >
                {{
                  (parseTicketPrice + pdvFees[paymentType].outerFee) | currency
                }}
              </b>
            </div>
            <div class="d-flex align-center justify-space-between">
              <span>A produtora recebe</span>
              <b
                :class="
                  pdvFees[paymentType].outerFee -
                    pdvFees[paymentType].innerFee !==
                  0
                    ? 'error--text'
                    : ''
                "
              >
                {{
                  (parseTicketPrice +
                    pdvFees[paymentType].outerFee -
                    pdvFees[paymentType].innerFee)
                    | currency
                }}
              </b>
            </div>
            <div class="d-flex align-center justify-space-between">
              <span>A ticketeira recebe</span>
              <b>{{ pdvFees[paymentType].innerFee | currency }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import payment from "@/utils/payment";
import html2canvas from "html2canvas";

export default {
  props: {
    fees: {
      type: Array,
      required: true,
    },
    organizationId: {
      type: String,
    },
    partyId: {
      type: String,
    },
    ticketBlockId: {
      type: String,
    },
    ticketGroupId: {
      type: String,
    },
  },
  data: () => ({
    ticketPrice: 100,
    pdvPaymentTypes: ["MONEY", "PIX", "DEBIT_CARD", "CREDIT_CARD"],
    paymentTypes: payment.paymentType,
  }),
  methods: {
    selectFee(fees) {
      const { ticketBlockId, ticketGroupId, partyId, organizationId } = this;
      const fee = fees.reduce((acc, fee) => {
        // ticketBlockId is the most specific
        if (acc?.ticketBlockId) return acc;
        if (fee.ticketBlockId && fee.ticketBlockId !== ticketBlockId)
          return acc;

        // ticketGroupId is the second most specific
        if (acc?.ticketGroupId) return acc;
        if (fee.ticketGroupId && fee.ticketGroupId !== ticketGroupId)
          return acc;

        // partyId is the third most specific
        if (acc?.partyId) return acc;
        if (fee.partyId && fee.partyId !== partyId) return acc;

        return fee;
      }, null);
      return fee;
    },
    calculateFee(fee) {
      const ticketPrice = this.parseTicketPrice;
      const { fixed, percent } = fee;
      const baseValue = ticketPrice + fixed;
      const tax = baseValue * (percent / 100) + fixed;
      return tax;
    },
    async copyAsImage() {
      try {
        await this.$nextTick();
        await new Promise((resolve) => setTimeout(resolve, 100));

        const node =
          this.$refs.componentToCopy.$el || this.$refs.componentToCopy;

        if (!node || !document.body.contains(node)) {
          throw new Error("Elemento não encontrado no documento");
        }

        const options = {
          useCORS: true,
          allowTaint: true,
          scrollY: -window.scrollY,
          windowWidth: document.documentElement.offsetWidth,
          windowHeight: document.documentElement.offsetHeight,
        };

        const canvas = await html2canvas(node, options);

        canvas.toBlob(async (blob) => {
          try {
            const item = new ClipboardItem({ "image/png": blob });
            await navigator.clipboard.write([item]);
            this.$emit("copy-success");
            alert("Imagem copiada para a área de transferência!");
          } catch (clipboardError) {
            console.error(
              "Erro ao copiar para a área de transferência:",
              clipboardError
            );
            this.$emit("copy-error", clipboardError);
            alert("Erro ao copiar para a área de transferência.");
          }
        }, "image/png");
      } catch (error) {
        console.error("Erro ao copiar como imagem:", error);
        this.$emit("copy-error", error);
        alert("Erro ao gerar a imagem. Por favor, tente novamente.");
      }
    },
  },
  computed: {
    parseTicketPrice() {
      return parseFloat(this.ticketPrice);
    },
    onlineFee() {
      const fees = this.groupedFees["PAGSEGURO"]?.["UNKNOWN"] || [];
      const fee = this.selectFee(fees);
      return {
        innerFee: this.calculateFee(fee.innerFee),
        outerFee: this.calculateFee(fee.outerFee),
      };
    },
    offlineFee() {
      const fees = this.groupedFees["OFFLINE"]?.["UNKNOWN"] || [];
      const fee = this.selectFee(fees);
      return {
        innerFee: this.calculateFee(fee.innerFee),
        outerFee: this.calculateFee(fee.outerFee),
      };
    },
    pdvFees() {
      const response = {};

      for (const paymentType of this.pdvPaymentTypes) {
        const fees = this.groupedFees["POS"]?.[paymentType] || [];
        const fee = this.selectFee(fees);
        response[paymentType] = {
          innerFee: this.calculateFee(fee.innerFee),
          outerFee: this.calculateFee(fee.outerFee),
        };
      }
      return response;
    },

    filteredFees() {
      return this.fees.filter((fee) => {
        if (!!fee.organizationId && fee.organizationId !== this.organizationId)
          return false;
        if (!!fee.partyId && fee.partyId !== this.partyId) return false;
        if (!!fee.ticketGroupId && fee.ticketGroupId !== this.ticketGroupId)
          return false;
        if (!!fee.ticketBlockId && fee.ticketBlockId !== this.ticketBlockId)
          return false;

        if (fee.innerFee.fixed === null || fee.innerFee.percent === null)
          return false;
        if (fee.outerFee.fixed === null || fee.outerFee.percent === null)
          return false;

        return true;
      });
    },
    groupedFees() {
      return this.filteredFees.reduce((acc, fee) => {
        if (!acc[fee.paymentMethod]) acc[fee.paymentMethod] = {};
        if (!acc[fee.paymentMethod][fee.paymentType])
          acc[fee.paymentMethod][fee.paymentType] = [];

        acc[fee.paymentMethod][fee.paymentType].push(fee);

        return acc;
      }, {});
    },
  },
  mounted() {
    this.$root.$on("fee:preview:price", (v) => {
      this.ticketPrice = v;
    });
  },
};
</script>

<style>
/* .fee-preview-card {
  box-shadow: none !important;
} */
</style>
